<template>
    <config-section
        :title="$t('auth.personal_info')"
        :description="$t('auth.personal_info_description')"
    >
        <div class="first-letter:uppercase font-semibold text-black mb-8">
            {{ $t('auth.profile_pic') }}
        </div>
        <siu
            class="mb-16"
            classes="h-124 w-124"
            :image="currentUser.image_url"
            is-small
            v-model="form.profile_image_queued_id"
            @success="avatarUploaded"
        ></siu>

        <div class="flex mb-16">
            <simple-input v-model="form.first_name" class="flex-grow mr-8" :disabled="currentUser.is_sso_user">
                {{ $t('auth.your_first_name') }}
            </simple-input>

            <simple-input v-model="form.last_name" class="flex-grow" :disabled="currentUser.is_sso_user">
                {{ $t('auth.your_last_name') }}
            </simple-input>
        </div>

        <simple-input v-model="form.email" :disabled="currentUser.is_sso_user">
            {{ $t('auth.email') }}
        </simple-input>

        <template #buttons>
            <simple-button
                :disabled="!form.isDirty()"
                display="secondary"
                icon="save"
                :loading="form.submitting"
                look="primary"
                v-if="!currentUser.is_sso_user"
                @click="saveProfile"
            >{{ $t('general.save') }}</simple-button>

            <div v-else>
                <banner
                    :description="$t('auth.sso_user_cannot_change_details')"
                    class="mt-8"
                    inline
                />
            </div>
        </template>

    </config-section>
</template>

<script>
import Form from '../etc/forms/Form';
import SingleImageUpload from './forms/SingleImageUpload.vue';
import SimpleButton from './ui/SimpleButton.vue';
import Input from './forms/Input.vue';
import * as users from '../services/UserService';
import User from '../models/User';
import { normalizeJson } from '../../shared/helpers';
import ConfigurationSection from './ConfigurationSection.vue';
import Banner from "./ui/Banner.vue";
import {mapStores, mapState} from "pinia";
import {useRepo} from "pinia-orm";
import {useMainStore} from "../state/store";
import {useAuthenticationStore} from '../state/modules/authentication';

export default {
    components: {
        Banner,
        'config-section': ConfigurationSection,
        'siu': SingleImageUpload,
        'simple-button': SimpleButton,
        'simple-input': Input,
    },
    setup() {
        const mainStore = useMainStore();
        return {mainStore};
    },
    data: function () {
        return {
            form: this.generateForm(),
        }
    },
    computed: {
        ...mapStores(useMainStore),
        ...mapState(useAuthenticationStore, ['currentUser']),
        currentUser() {
            return this.mainStore.currentUser;
        }
    },
    methods: {
        generateForm () {
            let user = this.mainStore.currentUser;

            return new Form([
                { name: 'first_name', value: user.first_name, rules: ['required']},
                { name: 'last_name', value: user.last_name, rules: ['required']},
                { name: 'email', value: user.email, rules: ['required']},
                { name: 'profile_image_queued_id', value: null }
            ])
        },
        avatarUploaded() {
            if (this.currentUser.is_sso_user) {
                this.$nextTick(this.saveProfile);
            }
        },
        saveProfile () {
            return this.form.submit(data => users.update(this.currentUser.id, {
                data: { attributes: data }
            })).then(result => {
                return useRepo(User).save(normalizeJson(result));
            });
        }
    }
}
</script>
